export interface PlanInfoDto {
  availablePlans: PlanItem[];
  userInfo: UserPlanInfo;
}

export interface UserPlanInfo {
  currentPlan: PlanType;
  card?: string;
  last4Digits?: string;
  expirationDate?: string;
  nextChargeDate?: string;
  nextChargeAmount?: number;
  cancelledAt?: string;
  validUntil?: string;
  aiRequestsUsed: number;
  aiRequestsLimit: number | null;
  aiRequestsRemaining: number | null;
}

export interface PlanItem {
  type: PlanType;
  price?: number;
  period?: PlanPeriod;
  isCurrent: boolean;
}

export enum PlanType {
  BASIC = 'BASIC',
  PRO = 'PRO',
  BUSINESS = 'BUSINESS',
}

export enum PlanPeriod {
  EVERY_MONTH = 'EVERY_MONTH',
  EVERY_3_MONTH = 'EVERY_3_MONTH',
  EVERY_6_MONTH = 'EVERY_6_MONTH',
  EVERY_YEAR = 'EVERY_YEAR',
}
